"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPhoneFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M15.678 13.368c-.635.29-.89.872-.89.872-.071.139-.51.68-1.318 1.623-3.562-.925-4.87-3.94-5.29-5.326.921-.795 1.446-1.225 1.573-1.29.003 0 .565-.303.889-.889.324-.586.19-1.24.19-1.24-.277-1.6-.483-2.763-.62-3.486 0 0-.079-.633-.664-1.154-.585-.52-1.3-.476-1.3-.476L4.027 2c-1.34 0-2.007.649-1.999 1.947-.269 5.302 1.458 9.815 5.181 13.538 3.025 3.025 7.19 4.553 12.394 4.553.09 0 .25-.013.477-.039 1.29.003 1.936-.663 1.936-1.999v-4.189s.06-.585-.411-1.225c-.472-.64-1.2-.737-1.2-.737a451.408 451.408 0 00-3.462-.666s-.63-.105-1.264.185h-.001z' }))); };
exports.default = SvgPhoneFilled;
//# sourceMappingURL=PhoneFilled.js.map